/**
 * Typography tokens — ported from the design reference.
 * Sans for everything; Mono for all numeric/financial values, document
 * numbers, codes, IDs, and dates in tables (a deliberate design rule).
 */
import { Platform } from 'react-native';

// On web the Google-Fonts family name is used directly; on native the bundled
// font's PostScript name is used. The names match what the design loads.
export const FontFamily = {
  sans: Platform.select({ web: 'IBM Plex Sans', default: 'IBMPlexSans-Regular' }) as string,
  sansMedium: Platform.select({ web: 'IBM Plex Sans', default: 'IBMPlexSans-Medium' }) as string,
  sansSemibold: Platform.select({ web: 'IBM Plex Sans', default: 'IBMPlexSans-SemiBold' }) as string,
  sansBold: Platform.select({ web: 'IBM Plex Sans', default: 'IBMPlexSans-Bold' }) as string,
  mono: Platform.select({ web: 'IBM Plex Mono', default: 'IBMPlexMono-Regular' }) as string,
  monoMedium: Platform.select({ web: 'IBM Plex Mono', default: 'IBMPlexMono-Medium' }) as string,
  monoSemibold: Platform.select({ web: 'IBM Plex Mono', default: 'IBMPlexMono-SemiBold' }) as string,
};

// Type scale (design --fs-xs … --fs-3xl), in px.
export const FontSize = {
  xs: 11,
  sm: 12,
  md: 13, // body default
  lg: 15,
  xl: 18,
  '2xl': 22,
  '3xl': 28,
} as const;

export const FontWeight = {
  regular: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
} as const;

export const LineHeight = {
  tight: 1.1,
  snug: 1.25,
  normal: 1.45,
  relaxed: 1.6,
} as const;

// Design uses negative letter-spacing on headings (-0.01em … -0.02em).
export const LetterSpacing = {
  tight: -0.4,
  tighter: -0.6,
  normal: 0,
  wide: 0.5, // uppercased table column headers / group labels
} as const;
